var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionGeneric',{attrs:{"to":_vm.to,"label":"Visualizza","iconClass":"fas fa-eye"}})}
var staticRenderFns = []

export { render, staticRenderFns }